import { Blur } from '@/components/Blur';
import { StepLayout } from '@/components/NewGeneralDialog/StepLayout';
import { WizardAnimationWrapper } from '@/components/WizardAnimationWrapper';
import { Documents } from '@/types/company';
import { Button, Stack, Typography } from '@mui/material';
import ArrowRightIcon from '@treyd-io/treyd-ui/icons/ArrowRightIcon';
import { useSession } from 'next-auth/react';
import { Trans, useTranslation } from 'react-i18next';
import { PoaDocumentCard } from './PoaDocumentCard';

interface PoaDocumentProps {
  document?: Documents.DocumentType;
  handleNextStep: (step?: number) => void;
  onNext: boolean;
}
export const PoaDocument = ({
  document,
  onNext,
  handleNextStep,
}: PoaDocumentProps) => {
  const { t } = useTranslation();
  const { data } = useSession({ required: true });
  const userCanSignAlone = data?.user?.can_sign_alone;

  return (
    <WizardAnimationWrapper onNext={onNext} firstStep>
      <StepLayout>
        <Stack gap={4}>
          <Stack gap={2}>
            <Typography variant="h3" color="text.primary">
              {t('poa_step_not_started_title_cond_false')}
            </Typography>
            <Typography variant="body1" color="text.primary">
              <Trans
                i18nKey="has_asked_you_to_sign_poa"
                values={{ name: document?.creator?.name }}
                components={{
                  blur: <Blur />,
                }}
              />
            </Typography>
          </Stack>
          <Stack gap={4}>
            {document && <PoaDocumentCard document={document} />}
            <Button
              variant="contained"
              color="primary"
              size="large"
              disabled={!userCanSignAlone}
              endIcon={<ArrowRightIcon />}
              sx={{
                alignSelf: { sm: 'flex-start' },
              }}
              onClick={() => handleNextStep()}>
              {t('review_and_sign')}
            </Button>
          </Stack>
        </Stack>
      </StepLayout>
    </WizardAnimationWrapper>
  );
};
